module.exports = __webpack_public_path__ + "static/img/5516_phase_function_Paper_PointsHejduk_Prediction.a29ca7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5516_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7MWH
// module chunks = 0